import request from '@/utils/request'

// ExistsLessonNoRegistration
export function existsLessonNoRegistration () {
  return request({
    timeout: 0,
    url: '/api/tutorcomm/ExistsLessonNoRegistration',
    method: 'post'
  })
}

// 获取当前打卡状态
export function getClockInStatus () {
  return request({
    url: '/api/TutorComm/GetClockInStatus',
    method: 'post'
  })
}

// Registration
export function registration () {
  return request({
    url: '/api/tutorcomm/Registration',
    method: 'post'
  })
}
// 修改密码，头部下拉面板中调用
export function updatePassword (currentPassword, newPassword, reEnterPassword) {
  return request({
    url: '/api/TutorComm/UpdatePassword',
    method: 'post',
    data: {
      OldPwd: currentPassword,
      NewPwd: newPassword,
      ReNewPwd: reEnterPassword
    }
  })
}
// 连续缺席实验
export function getTutorAbsentNotice () {
  return request({
    url: `/api/TutorComm/GetTutorAbsentNotice`,
    method: 'Post',
  })
}
// 
export function absentNoticeOperate (data) {
  return request({
    url: `/api/TutorComm/AbsentNoticeOperate`,
    method: 'Post',
    data:data
  })
}
// 获取老师课程消息提醒数据
export function getTutorClassMsgList () {
  return request({
    url: '/api/tutorcomm/TutorClassMsgList',
    method: 'post'
  })
}
// 老师拒绝某项政策
export function noticeSendRefuse (mid, reason) {
  return request({
    url: '/api/tutorcomm/NoticeSendRefuse',
    method: 'post',
    data: {
      mid,
      reason
    }
  })
}
// 更新消息状态
export function readClassMsg (Mid) {
  return request({
    url: '/api/tutorcomm/ReadClassMsg',
    method: 'post',
    data: {
      Mid
    }
  })
}
// 获取老师系统消息数据
export function getTutorSysMsg () {
  return request({
    url: '/api/tutorcomm/TutorSysMsg',
    method: 'post'
  })
}

// 改变系统信息状态
export function readSysMsg (Mid) {
  return request({
    url: '/api/tutorcomm/ReadSysMsg',
    method: 'post',
    data: {
      Mid
    }
  })
}

// 修改工资账户是否需要老师确认
export function teacheIsIsPaypal () {
  return request({
    url: '/api/tutorcomm/TeacheIsIsPaypal',
    method: 'post'
  })
}

// 确认工资账户
export function updateTutorIsPaypal () {
  return request({
    url: '/api/tutorcomm/UpdateTutorIsPaypal',
    method: 'post'
  })
}

//
export function stuComments (startTime, endTime, pageIndex, pageSize, level) {
  return request({
    url: '/api/tutorcomm/StuComments',
    method: 'post',
    data: {
      startTime,
      endTime,
      pageIndex,
      pageSize,
      level
    }
  })
}

export function getStuCommentLable () {
  return request({
    url: '/api/tutorcomm/GetStuCommentLable',
    method: 'post'
  })
}
